<template>
  <div class="bindBox">
    <div class="infoBox">
      <ul>
        <li>
          <input
            type="text"
            v-model="info.cardid"
            placeholder="会员卡卡号"
          />
        </li>
        <li>
          <input
            type="text"
            v-model="info.password"
            placeholder="会员卡密码"
          />
        </li>
      </ul>
      <div class="tip">
        提示：实体卡请查看卡片反面8位数字，电子卡请查看短信内8位密码。
      </div>
    </div>
    <div class="opation">
      <p
        class="submit"
        @click="goto('submit')"
      >绑定</p>
      <p class="rule">
        开通会员代表接受 <span @click="goto('vip')">《会员服务协议》</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "兑换卡券",
    };
  },
  data() {
    return {
      info: {
        cardid: "",
        password: "",
      },
    };
  },
  components: {},
  mounted() { },
  methods: {
    goto(type) {
      var obj = {};
      switch (type) {
        case "submit":
          this.submit();
          break;
        case "vip":
          var url = "/common/protocol/vip";
          break;
        default:
          break;
      }
      if (url) {
        this.$router.push({
          path: url,
          query: obj,
        });
      }
    },
    submit() {
      var _this = this;
      if (!this.info.cardid) {
        this.util.toast({ msg: "请输入会员卡卡号" });
        return false;
      }
      if (!this.info.password) {
        this.util.toast({ msg: "请输入会员卡密码" });
        return false;
      }
      var obj = {
        gserialno: this.info.cardid,
        passcode: this.info.password,
      };
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      }
      this.$post("/iart-api-crm/api/crm/certificate/rechargeCard", obj).then(
        (res) => {
          if (this.util.processingData(res)) {
            if (res.code == 1) {
              if (res.data.rtncode == 1) {
                this.util.toast({ msg: "会员卡绑定成功" });
                setTimeout(() => {
                  _this.$route.back();
                }, 1000);
              } else {
                this.util.toast({ msg: res.data.rtnmsg });
              }
            } else {
              this.util.toast({ msg: res.message });
            }
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.bindBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(244, 244, 247, 1);
  padding: 6vh 32px 0;
  .infoBox {
    ul {
      li {
        background: #fff;
        padding: 16px;
        border-radius: 3px;
        input {
          width: 100%;
          font-size: 14px;
          line-height: 20px;
          color: rgba(45, 45, 45, 1);
        }
        input::placeholder {
          color: rgba(45, 45, 45, 0.3);
          font-size: 14px;
          line-height: 20px;
        }
      }
      li:not(:last-child) {
        margin-bottom: 16px;
      }
    }
    .tip {
      font-size: 12px;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.4);
      margin-top: 22px;
    }
  }
  .opation {
    margin-top: 16px;
    .submit {
      font-size: 14px;
      line-height: 20px;
      color: rgba(255, 255, 255, 1);
      font-weight: 600;
      background: rgba(67, 71, 97, 1);
      border-radius: 3px;
      text-align: center;
      padding: 13px 0;
    }
    .rule {
      text-align: center;
      margin-top: 16px;
      font-size: 12px;
      line-height: 17px;
      color: rgba(174, 175, 177, 1);
      font-weight: 400;
      span {
        color: rgba(67, 71, 97, 1);
      }
    }
  }
}
</style>